<template>
	<MainLayout>
		<!-- Main Layout -->
		<div class="container">
			<div class="box">
				<!-- header -->
				<b-button class="float-right" variant="primary" @click="newFormQuote">
					{{ $t('bookings.newRes') }}
				</b-button>
				<h2 class="inline-heading">{{ $t('global.bookings') }}</h2>
				<!-- /header -->
				<hr>

				<!-- filters -->
				<b-form @submit.prevent="() => { $root.$emit('bv::refresh::table', 'reservations-index-list') } ">
					<b-row>
						<!-- res id -->
						<b-form-group class="col-lg-3 col-md-4" label="Res ID">
							<b-form-input :class="{'active-filter':filters.id}" v-model="filters.id" type="number"/>
						</b-form-group>

						<!-- client name -->
						<b-form-group class="col-lg-3 col-md-4" :label="$t('bookings.clientName')">
							<b-form-input :class="{'active-filter':filters.clientFullName}" v-model="filters.clientFullName" type="text"/>
						</b-form-group>

						<!-- airports -->
						<b-form-group class="col-lg-3 col-md-4" :label="$t('bookings.airports')">
							<multiselect
								:class="{'active-filter':filters.airport.length>0}"
								v-model="filters.airport"
								:options="airportsOpts"
								group-label="group"
								group-values="options"
								group-select
								multiple
								label="text"
								track-by="value"
								:placeholder="$t('global.all')"
								:option-height="10"
								taggable
							/>
						</b-form-group>

						<!-- service type -->
						<b-form-group class="col-md-3" :label="$t('bookings.serviceType')">
							<multiselect
								:class="{'active-filter':filters.serviceType.length>0}"
								v-model="filters.serviceType"
								:options="serviceTypesOpts"
								group-label="group"
								group-values="options"
								group-select
								multiple
								label="text"
								track-by="value"
								:placeholder="$t('global.all')"
								taggable
							/>
						</b-form-group>

						<!-- service date from -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.serviceDateFrom')">
							<b-form-datepicker
								:locale="$root.store.state.currentUser.lang"
								:class="{'active-filter':filters.pickupStartDate}"
								reset-button
								v-model="filters.pickupStartDate"
							/>
						</b-form-group>

						<!-- service date to -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.serviceDateTo')">
							<b-form-datepicker
								:locale="$root.store.state.currentUser.lang"
								:class="{'active-filter':filters.pickupEndDate}"
								reset-button
								v-model="filters.pickupEndDate"
							/>
						</b-form-group>

						<!-- bookingDate from -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.bookingDateFrom')">
							<b-form-datepicker
								:locale="$root.store.state.currentUser.lang"
								:class="{'active-filter':filters.reservationStartDate}"
								reset-button
								v-model="filters.reservationStartDate"
							/>
						</b-form-group>

						<!-- bookingDate to -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.bookingDateTo')">
							<b-form-datepicker
								:locale="$root.store.state.currentUser.lang"
								:class="{'active-filter':filters.reservationEndDate}"
								reset-button
								v-model="filters.reservationEndDate"
							/>
						</b-form-group>

						<!-- calcel date from -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.cancelDateFrom')">
							<b-form-datepicker
								:locale="$root.store.state.currentUser.lang"
								:class="{'active-filter':filters.cancelationStartDate}"
								reset-button
								v-model="filters.cancelationStartDate"
							/>
						</b-form-group>

						<!-- calcel date to -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.cancelDateTo')">
							<b-form-datepicker
								:locale="$root.store.state.currentUser.lang"
								:class="{'active-filter':filters.cancelationEndDate}"
								reset-button
								v-model="filters.cancelationEndDate"
							/>
						</b-form-group>

						<!-- service status -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.serviceStatus')">
							<multiselect
								:class="{'active-filter':filters.status.length>0}"
								v-model="filters.status"
								:options="statusOpts"
								group-label="group"
								group-values="options"
								group-select
								multiple
								label="text"
								track-by="value"
								:placeholder="$t('global.all')"
								taggable
							/>
						</b-form-group>
						
						<!-- trip type -->
						<b-form-group class="col-lg-2 col-md-4" :label="$t('bookings.tripType')">
							<b-form-select :class="{'active-filter':filters.trip}" v-model="filters.trip" :options="tripOpts"/>
						</b-form-group>

						<b-col lg="8" class="text-right pt-3">
							<b-row>
								<b-form-group class="col-md-12">
									<b-button :disabled="exportLoading" class="mr-2" variant="warning" @click="exportXLS">
										<span v-if="!exportLoading">{{ $t('bookings.export') }} XLS</span>
										<span v-else><b-spinner small></b-spinner> {{ $t('bookings.exporting') }}...</span>
									</b-button>
									<b-button class="btn-middle" @click="filters = {...defaultFilters}; $root.$emit('bv::refresh::table', 'reservations-index-list')" variant="info">{{ $t('global.clean') }}
									</b-button>
									<b-button type="submit" variant="primary">{{ $t('global.search') }}</b-button>
								</b-form-group>
							</b-row>
						</b-col>
					</b-row>
				</b-form>
				<!-- /filters -->

				<hr>
				<!-- ts status -->
				<h5 class="my-4">
					<b-badge
						v-for="(aux,i) in $root.auxVars.transportServiceStatusOpts"
						:key="i"
						:variant="aux.class"
						class="mr-2"
					>
						{{ $t(`bookings.serviceStatusOpts.${aux.value}`) }}
					</b-badge>
				</h5>
				<!-- /ts status -->

				<AjaxTable
					id="reservations-index-list"
					ref="childtable"
					stacked="xl"
					:filters="filtersClean"
					:columns="filteredColumns"
					:items-filter="itemsFilter"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="transport-services"
					responsive
				>
					<template #cell(actions)="row">
						<div class="text-center">
							<b-button @click=" event => viewForm(row.item, row.index, event, row.item)"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="visibility"></md-icon>
							</b-button>
						</div>
					</template>
					<template #cell(reservationId)="row">
						<md-icon icon="home" v-if="row.item.source == 'scadmin'" v-b-tooltip.hover v-b-tooltip.right :title="$t('tooltips.scadmin')"/>
						<b-badge variant="info" v-else v-b-tooltip.hover v-b-tooltip.right :title="$t('tooltips.be')">PV</b-badge>
						{{row.item.reservationId}}
					</template>
					<template #cell(clientName)="row">
						{{ row.item.reservation.client.firstName }}
						{{ row.item.reservation.client.lastName }}
					</template>
					<template #cell(pickup)="row">
						{{ row.item.pickup.name }}
					</template>
					<template #cell(dropoff)="row">
						{{ row.item.dropoff.name }}
					</template>
					<template #cell(passengers)="row">
						{{$t('bookings.adults')}}: {{row.item.reservation.adults}}<br/>
						{{$t('bookings.kids')}}: {{row.item.reservation.children}}<br/>
						{{$t('bookings.infants')}}: {{row.item.reservation.infants}}
					</template>
					<template #cell(serviceType)="row">
						{{ row.item.serviceType.name }}
					</template>
					<template #cell(pickupDatetime)="row">
						{{row.item.pickupDatetime | moment('D MMM YYYY HH:mm')}}
					</template>
					<template #cell(flightDatetime)="row">
						<span
							:class="
								row.item.flightValidationStatus !== 'none'
									? 'text-success text-center'
									: 'text-danger text-center'
							"
						>
							<md-icon
								:icon="
									row.item.flightValidationStatus !== 'none'
										? 'check_circle'
										: 'info'
								"
							/>
						</span>
						{{ row.item.flightDatetime }} /
						{{ row.item.flightNumber }}
					</template>
					<template #cell(bookingPriceTotal)="row">
						{{ formatLblPrice(row.item.bookingPriceTotal) }}
					</template>
					<template #cell(bookingCurrency)="row">
						{{ row.item.bookingCurrency !== '' ? row.item.bookingCurrency.toUpperCase() : '' }}
					</template>
					<template #cell(reservationDatetime)="row">
						{{row.item.reservation.reservationDatetime | moment('D MMM YYYY HH:mm')}}
					</template>
					<template #cell(status)="row">
						{{ statusLabels[row.item.status] }}
					</template>
				</AjaxTable>
			</div>
		</div>
		<!-- /Main Layout -->

		<!-- Single Modal -->
		<Single
			:tsSelectedId="selected.tsSelectedId"
			:model-id="selected.modalModelId"
			:copy-from-id="selected.copyResId"
			@changeId="selected.modalModelId = $event"
			@onCopyRes="copyCurrentRes"
			v-model="form.add"
		/>
		<!-- Single Modal -->

		<!-- New reservation -->
		<FormQuote
			v-model="quote.showForm"
		/>
		<!-- /New reservation -->

		<!-- Notification -->
		<vue-snotify></vue-snotify>
	</MainLayout>
</template>

<script>
import MainLayout from '../layout/MainLayout.vue'
import Multiselect from 'vue-multiselect'
import FormQuote from "./quote/FormQuote";
import {mapMutations,mapState} from 'vuex'
import AjaxTable from "../../helpers/AjaxTable";
import Single from "./Single";
import numeral from "numeral";

export default {
	components: {
		MainLayout,
		Multiselect,
		Single,
		// AjaxTableReservations,
		FormQuote,
		AjaxTable
	},
	data() {
		let defaultFilters = {
			id: '',
			clientFullName: '',
			airport: [],
			serviceType: [],
			pickupStartDate: '',
			pickupEndDate: '',
			cancelationStartDate: '',
			cancelationEndDate: '',
			reservationStartDate: '',
			reservationEndDate: '',
			trip: 0,
			status: [],
		}
		return {
			// new
			form: {
				add: false,
			},
			selected: {
				modalModelId: -1,
				tsSelectedId: -1,
				copyResId: -1
			},

			itemsSelected: [],
			items: [],
			modelId: -1,
			showSingleModal: false,
			exportLoading: false,
			showSelectAll: false,
			sortBy: 'reservationId',
			sortDesc: true,
			filters: {...defaultFilters},
			defaultFilters: {...defaultFilters},
			modelColumns: [
				{key: 'reservationId', label: 'Res ID', sortable: true, tdClass: 'one-line-fix'},
				{key: 'clientName', label: this.$t('bookings.client')},
				{key: 'pickup', label: 'Pickup'},
				{key: 'dropoff', label: 'Dropoff'},
				{key: 'passengers', label: this.$t('bookings.passengers')},
				{key: 'pickupDatetime', label: this.$t('bookings.pickupDate'), sortable: true, tdClass: 'one-line-fix'},
				{key: 'serviceType', label: this.$t('bookings.serviceType')},
				{key: 'trip', label: this.$t('bookings.trip')},
				{key: 'bookingPriceTotal', label: this.$t('payments.bookingPrice')},
				{key: 'bookingCurrency', label: this.$t('rates.currency')},
				{key: 'reservationDatetime', label: this.$t('bookings.bookingDatetime')},
				{key: 'actions', label: this.$t('bookings.actions')},
			],
			selecAsigValid: [],
		}
	},
	computed: {
		// new
		...mapState("reservation", ["quote"]),

		filteredColumns() {
			let aux = [];
			if (this.showSelectAll) {
				aux.push({key: 'selected', label: ''});
			}
			aux = aux.concat(this.modelColumns);
			return aux;
		},
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				airport: this.filters.airport.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupEndDate: this.filters.pickupEndDate,
				reservationStartDate: this.filters.reservationStartDate,
				reservationEndDate: this.filters.reservationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				trip: this.filters.trip,
				status: this.filters.status.map(aux => aux.value),
			}
		},
		airportsOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{group: this.$t('global.selectAll'), options: this.$root.auxVars.airportsOpts}]
		},
		statusOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{
				group: this.$t('global.selectAll'),
				options: this.$root.auxVars.transportServiceStatusOpts.map(opt => ({
					value: opt.value,
					text: this.$t(`bookings.serviceStatusOpts.${opt.value}`)
				}))
			}]
		},
		tripOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			let aux = [...this.$root.auxVars.tripOpts]
			aux.unshift({value: 0, text: this.$t('global.all')})
			return aux
		},
		serviceTypesOpts() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			return [{group: this.$t('global.selectAll'), options: this.$root.auxVars.serviceTypesOpts}]
		},
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts
			let opts = {}
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text
			}
			return opts
		},
		trackingStatusLabels() {
			// eslint-disable-next-line
			this.$root.$i18n.locale
			let vars = this.$root.auxVars.transportServiceTrackingStatusOpts
			let opts = {}
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = this.$t(`bookings.trackingStatusOpts.${vars[i].value}`)
			}
			return opts
		},
		serviceStatusVariants() {
			let aux = {}
			this.$root.auxVars.transportServiceStatusOpts.map(status => {
				aux[status.value] = status.class
			})
			return aux
		},
	},
	methods: {
		// new
		...mapMutations("reservation", ["SET_RESET_MODEL","SET_UPDATE_QUOTE_PROPS"]),

		newFormQuote(){
			this.selected.copyResId = -1;
			this.selected.modalModelId = -1;
			this.SET_RESET_MODEL();
			this.SET_UPDATE_QUOTE_PROPS({showForm:true})
		},
		viewForm(item) {
			this.selected.tsSelectedId = item.id;
			this.selected.copyResId = -1;
			this.selected.modalModelId = item.reservationId;
			this.form.add = true
		},

		copyCurrentRes() {
			const aux = this.modelId
			this.modelId = -1
			this.$refs.single.copyFromId(aux)
		},
		itemsFilter(items) {
			return items.map(item => ({...item, _rowVariant: this.serviceStatusVariants[item.status]}));
		},
		exportXLS() {
			this.exportLoading = true
			this.$root.api.get(`/transport-services/export`, {
				params: {
					sortBy: this.sortBy,
					sortOrder: this.sortDesc ? 'desc' : 'asc',
					lang: this.$root.store.state.currentUser.lang,
					filters: this.filtersClean,
				},
				responseType: "blob"
			}).then((res) => {
				let blob = new Blob([res.data], {
					type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
				});
				let url = window.URL.createObjectURL(blob);
				let a = document.createElement("a");
				a.href = url;
				a.download = "TransportServices.xlsx";
				a.click();
				window.URL.revokeObjectURL(url);
				this.exportLoading = false
			}).catch(error => {
				this.$root.handleRequestError(error)
				this.exportLoading = false
			});
		},
		formatLblPrice(price) {
			let priceF = numeral(price).format('0,0.[00]');
			return "$" + priceF // return "$" + priceF + " " + (currency.toUpperCase())
		},
	},
	mounted() {
		console.log('mountedd')

		this.$root.auxVars.loadResourcesOpts({
			vm: this,
			resourceNames: ['serviceTypesOpts', 'airportsOpts', 'allServiceTypesOpts']
		});

		if (localStorage.getItem('reservation-filters')) {
			try {
				this.filters = {...this.defaultFilters, ...JSON.parse(localStorage.getItem('reservation-filters'))}
			} catch (e) {
				localStorage.removeItem('reservation-filters');
			}
		}
	},
	watch: {
		filters: {
			handler(newFilters) {
				localStorage.setItem('reservation-filters', JSON.stringify(newFilters))
			},
			deep: true,
		},
	},
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style>
.one-line-fix {
	white-space: nowrap;
}

.multiselect__tags {
	max-height: 150px;
	overflow-y: auto;
	overflow-y: auto;
}

.active-filter {
	border: 2px solid #021D3E;
}

.snotifyToast__title {
	font-size: 1.5em;
}

.inline-heading {
	display: inline;
}

.inline-button {
	margin-bottom: 10px;
}

</style>

<style scoped>
.btn-middle {
	margin-right: 8px;
}
</style>
